export const initialState = {
	albums: [],
	allAlbumsLoaded: false,
	allFeaturesLoaded: false,
	allReviews: [],
	artists: [],
	features: [],
	featureCategories: [],
	genres: [],
	impersonationUser: null,
	isAuthenticating: false,
	isFetchingRecentAlbums: false,
	isFetchingFeatures: false,
	isModalOpen: false,
	labels: [],
	lastAlbumDocument: null,
	lastFeatureDocument: null,
	lastReviewDocument: null,
	legacyReviews: [],
	notifications: [/*{message: 'this is a basic notification', type: 'error'}*/],
	recentReviews: [],
	selectedArtist: null,
	selectedAlbum: null,
	selectedFeature: null,
	selectedLabels: [],
	selectedGenres: [],
	users: []
}

export default initialState;
